import { Box, Global, Text } from "@mantine/core";
import "./App.css";
import AppContainer from "./components/AppContainer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GlobalStyles from "./components/GlobalStyles";
import HomePage from "./HomePage";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";
import ContactPage from "./ContactPage";
import SupportPage from "./SupportPage";
import { ThemeProvider } from "./components/ThemeProvider";

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />
      <BrowserRouter>
        <Routes>
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/support' element={<SupportPage />} />
          <Route path='/privacy' element={<PrivacyPage />} />
          <Route path='/terms' element={<TermsPage />} />
          <Route path='/changelog' element={<></>} />
          <Route path='/*' element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
